import { cva } from 'class-variance-authority';

import { Dialog } from '@/components/atoms';
import { cn } from '@/lib/utils/tailwind';

import type { ReactElement, ReactNode } from 'react';

export const modalVariants = cva(
  [
    'fixed',
    'z-3000',
    'top-1/2',
    'left-1/2',
    'transition',
    // 'ease-in-out',
    // 'data-[state=open]:animate-in',
    // 'data-[state=closed]:animate-out',
    // 'data-[state=closed]:duration-300',
    // 'data-[state=open]:duration-500',
    '-translate-x-1/2',
    '-translate-y-1/2',
    'shadow-lg',
  ],
  {
    variants: {
      size: {
        sm: 'max-w-sm p-4',
        md: 'max-w-md p-6',
        lg: 'max-w-2xl p-8',
      },
      theme: {
        default: [
          'bg-(--color-surface-neutral-softer)',
          'text-(--color-text-primary)',
        ],
      },
    },
    defaultVariants: {
      size: 'md',
      theme: 'default',
    },
  },
);

type ModalProps = {
  isOpen?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  trigger?: ReactElement;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  theme?: 'default';
  className?: string;
};

const Modal = ({
  isOpen,
  defaultOpen,
  onOpenChange,
  trigger,
  size = 'md',
  theme = 'default',
  className,
  children,
}: ModalProps) => {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={onOpenChange}
      defaultOpen={isOpen === undefined ? defaultOpen : undefined}
    >
      {trigger}
      <Dialog.Portal>
        <Dialog.Overlay
          className={cn(
            'fixed inset-0 z-40 bg-black/50 backdrop-blur-sm transition-opacity',
          )}
        />
        <Dialog.Content
          className={cn(modalVariants({ size, theme }), className)}
        >
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export { Modal, type ModalProps };
